import { render, staticRenderFns } from "./TDialog.vue?vue&type=template&id=b38df928&scoped=true&"
import script from "./TDialog.vue?vue&type=script&lang=js&"
export * from "./TDialog.vue?vue&type=script&lang=js&"
import style0 from "./TDialog.vue?vue&type=style&index=0&id=b38df928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38df928",
  null
  
)

/* custom blocks */
import block0 from "./TDialog.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports